import React  from 'react';
import {FieldViewProps} from "../../../../render/view";
import FieldUrl_ActionClick from "../actions/url-click";

export default function FieldUrl_View(props:FieldViewProps) {

    const value = _.get(props.model, props.field.fieldId, null)

    const onClick = (e:React.SyntheticEvent) => {
        e.stopPropagation()
        FieldUrl_ActionClick(value)
    }

    const classes = Classes("ui5-link-default no-underline txt-truncate", props.className)

    return (
        <div className  =   {classes}
             onClick    =   {onClick}>
            {value}
        </div>
    )
}
